import { boundarySettingsAPI } from "../API/boundarySettingsAPI";

const API = boundarySettingsAPI;
export const boundarySettingService = {
  //////// 取得邊界設定已儲存內容
  fetchBoundarySettingContent(rootId, userId, reportId, year) {
    const requestBody = {
      rootId: rootId,
      userId: userId,
      reportId: reportId,
      year: year,
      trigger: false,
    };

    return API.getBSContent(requestBody);
  },

  //////// 儲存組織邊界資料
  saveBS(boundaryContent, userId, year, isCustom, remark) {
    const requestBody = {
      ...boundaryContent,
      levelOfAssurance:
        boundaryContent.levelOfAssurance == null
          ? null
          : Number(boundaryContent.levelOfAssurance),
      userId: userId,
      reportId: 1,
      year: year,
      isCustom: isCustom,
      remark: remark,
    };

    return API.saveBS(requestBody);
  },

  //////// 同步選定年份的組織邊界資料
  syncBS(rootId, userId, originalYear, targetYear) {
    const requestBody = {
      rootId: rootId,
      userId: userId,
      originalYear: originalYear,
      targetYear: targetYear,
    };

    return API.syncBS(requestBody);
  },

  //////// 刪除該年份的組織邊界資料
  deleteBS(rootId, year) {
    return API.deleteBS(rootId, year);
  },

  //////// 取得已經設定過的年份
  fetchSetYears(userId) {
    return API.getSetYears(userId);
  },

  //////// 取得報告邊界的問題資料
  fetchRBData(userId, year, isCustom, standardId) {
    const requestBody = {
      userId: userId,
      reportId: 1,
      year: year,
      isCustom: isCustom,
      standardId: standardId,
    };

    return API.getRBData(requestBody);
  },

  //////// 儲存報告邊界資料
  saveRB(userId, year, isCustom, standardId, requestBody) {
    return API.saveRB(userId, year, isCustom, standardId, requestBody);
  },

  //////// 取得重大性評估的答案資料
  fetchMaterialityData(userId, year, isCustom, standardId) {
    const requestBody = {
      userId: userId,
      reportId: 1,
      year: year,
      isCustom: isCustom,
      standardId: standardId,
    };

    return API.getMaterialityData(requestBody);
  },

  //////// 儲存重大性評估資料
  saveMaterialityData(userId, year, isCustom, standardId, remark, requestBody) {
    ////////將data扁平化 => 去掉category
    let data = { requestBody };
    let flat = Object.values(data).flat();
    const flatData = Object.values(flat[0]).flat();
    const finalData = {};
    finalData.data = flatData;
    finalData.remark = remark;

    return API.saveMaterialityData(
      userId,
      year,
      isCustom,
      standardId,
      finalData,
    );
  },

  //////// 取得稽核紀錄
  fetchLog(userId, year) {
    return API.getLog(userId, year);
  },

  //////// 檢查設定年與基準年標準是否一致
  checkStandardByYear(userId, originalYear, targetYear) {
    return API.checkStandardByYear(userId, originalYear, targetYear);
  },

  //////// 取得基準年度的 standardId
  getStandardIdByYear(userId, year) {
    return API.getStandardIdByYear(userId, year);
  },

  hasRemovalMitigationData(year) {
    return API.hasRemovalMitigationData(year);
  },
};
